import { createContext } from 'react';
import type {
    DefinedCustomControlData,
    IProcessAction,
    IProcessActivity,
    IServiceStartingPoint,
} from '@common/interfaces';
import type { CreateProcessRequestBody, PerformProcessActionRequestBody } from '@common/interfaces/api/patientsApi';
import type { PerformProcessActionResult } from '@common/interfaces/performProcessAction';
import type { ProcessActivityCancelValidated } from '@common/validation/processActivityCancel';

export type PatientEpisodeCategoryCarePathContextValue = Readonly<{
    activeModifyActivity?: IProcessActivity;
    activeProcessAction?: IProcessAction;
    activeStartingPoint?: IServiceStartingPoint;
    cancelProcessActivityAndReload: (
        processActivityId: string,
        reason: ProcessActivityCancelValidated
    ) => Promise<void>;
    deleteProcessActionDraft: (processAction: IProcessAction) => Promise<void>;
    isSavingAndReloading: boolean;
    saveModifiedCustomControlData: (
        processActivityId: string,
        customControlData: DefinedCustomControlData
    ) => Promise<void>;
    saveProcess: (process: CreateProcessRequestBody) => Promise<void>;
    saveProcessAction: (
        processId: string,
        processAction: PerformProcessActionRequestBody
    ) => Promise<PerformProcessActionResult>;
    setActiveModifyActivity: (processActivity?: IProcessActivity) => void;
    setActiveProcessAction: (processAction?: IProcessAction) => void;
    setActiveStartingPoint: (startingPoint?: IServiceStartingPoint) => void;
}>;

export const PatientEpisodeCategoryCarePathContext = createContext<PatientEpisodeCategoryCarePathContextValue | null>(
    null
);
